import React, { useState, useEffect } from "react";
import {
  EMPLOYEE_API_04,
  USERS_API_05,
  USERS_COMPANY_USERS_API,
  USERS_CREATE_USER_API,
  FILE_API_01,
} from "../../api/ApiModel";
import { useSelector, useDispatch } from "react-redux";
import {
  CON_PASSWORD_USER,
  CON_STATUS_ACTIVE,
} from "../../utils/sys/Constants";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  Typography,
  Divider,
  Button,
  Snackbar,
  Alert,
  IconButton,
} from "@mui/material";
import {
  externalpostApi,
  externalgetApi,
  externalImagepostApi,
} from "../../services/external/externalApis";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import EditIcon from "@mui/icons-material/Edit";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { IMAGEBASEURL } from "../../api/EndPoints";
const MyProfile = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [imageData, setImageData] = useState("");
  const [filePath, setFilePath] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [originalImagePath, setOriginalImagePath] = useState(null);

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERNAME, USERREFCODE } = SYS_USER.USER_PARAM || {};

  const [profileData, setProfileData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [error, setError] = useState(null);



  // API call
  // API call
  useEffect(() => {
    const fetchProfileData = async () => {
      if (!COMPCODE || !USERNAME || !USERREFCODE) {
        console.error("COMPCODE, USERNAME, or USERREFCODE is not defined.");
        return;
      }

      try {
        const params = {
          COMPCODE: COMPCODE,
          STS: CON_STATUS_ACTIVE,
        };

        const response = await externalgetApi(
          USERS_COMPANY_USERS_API,
          "GET",
          params
        );
        console.log("API Response User Data:", response); // Check the API response

        // Filter the response based on USERREFCODE
        const filteredResponse = response.filter(
          (user) => user.USERREFCODE === USERREFCODE
        );
        if (filteredResponse.length > 0) {
          const userData = filteredResponse[0];
          setProfileData(userData);
          setOriginalImagePath(userData.IMAGEPATH);
          // Access the first element of the filtered array
          console.log("profile data", filteredResponse[0]);
        } else {
          console.error("No matching user found.");
        }
        setDataLoaded(true);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        setError(error);
      } finally {
        setDataLoaded(true);
      }
    };

    fetchProfileData();
  }, [COMPCODE, USERNAME, USERREFCODE]); // Include COMPCODE and USERNAME as dependencies

  if (error) {
    return <Typography color="error">Error loading profile data</Typography>;
  }

  const profileImage = profileData?.IMAGEPATH;

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleEditClick = async () => {
    if (!profileData) {
      console.error("Profile data is not loaded yet.");
      return;
    }
    let finalImagePath = imageData ? imageData : profileData.IMAGEPATH || null;

    const payload = {
      compcode: profileData.COMPCODE,
      loccode: profileData.LOCCODE || "", // Use empty string if undefined
      userrefcode: String(profileData.USERREFCODE),
      username: profileData.USERNAME,
      firstname: profileData.FIRSTNAME,
      lastname: profileData.LASTNAME,
      imagepath: finalImagePath,
      password: CON_PASSWORD_USER, // Keeping it empty if not changing
      expdate: profileData.EXPDATE,
      groupcode: profileData.GROUPCODE,
      sts: CON_STATUS_ACTIVE,
      locdate: "2022-10-12", // Keeping it empty if not changing
    };

    try {
      const jsonString = JSON.stringify(payload);
      console.log("Payload for API call:", jsonString);
      const responseData = await externalpostApi(
        USERS_CREATE_USER_API,
        payload
      );
      console.log("Success:EEEEEEEEEEEEE", responseData);

      setSnackbarMessage("User added successfully!");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    }
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }

    const fileType = file.type;
    if (fileType !== "image/jpeg" && fileType !== "image/png") {
      console.error("Only JPG and PNG files are allowed.");
      return;
    }

    // Preview the selected image
    const reader = new FileReader();
    reader.onload = (e) => setImageData(e.target.result);
    reader.readAsDataURL(file);

    // Prepare the companyData
    const companyData = new FormData();
    companyData.append("file", file);

    try {
      // Construct the API URL with the COMPCODE in the query string
      const apiUrl = `${FILE_API_01}?COMPCODE=${encodeURIComponent(COMPCODE)}`;
      console.log("Sending request to API:", apiUrl);

      // Send the file to the server
      const response = await externalImagepostApi(apiUrl, companyData);

      // Log the complete response for debugging
      console.log("API Response:", response);

      // Safely extract the filePath from the response data
      const { filePath } = response || {};
      if (filePath) {
        // Convert Windows-style path to URL-friendly format
        const formattedPath = filePath.replace(/\\/g, "//");

        // Assuming you need the full URL path, prepend a base URL
        const fullPath = `${IMAGEBASEURL}${formattedPath}`;

        // Set the file path (you can adjust the base URL as necessary)
        setFilePath(fullPath);
        setImageData(fullPath);
        console.log("File uploaded successfully:", fullPath);
      } else {
        console.error(
          "File path not found in the API response:",
          response.data
        );
      }
    } catch (error) {
      console.error("Error uploading file:", error);

      // Handle API response errors
      if (error.response) {
        console.error("API Response Error Data:", error.response.data);
      } else {
        console.error("Network or other error:", error.message);
      }
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar2}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                {/* <Link underline="none">Employee</Link> */}
                <Link underline="none">MyProfile</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={{ ...styles.mp_box_container }}>
        <Grid container spacing={2}>
          {/* Avatar Section */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {" "}
            <Box
              sx={{
                ...styles.cb_col_1,
                // maxHeight: "100vh",
                // height: {
                //   xs: "65vh",
                //   sm: "65vh",
                //   md: "65vh",
                //   lg: "75vh",
                //   xl: "75vh",
                // },
                overflowY: "auto",

                borderRadius: 1,
                boxShadow: 2,
                // minHeight: "40vh",
                display: "flex",
                // flexDirection: "column",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "column",
                  lg: "row",
                  xl: "row",
                },
                alignItems: "center",
                p: 3,
                // width: "100%",
                transition: "box-shadow 0.3s",
                "&:hover": { boxShadow: 6 },
                background: `linear-gradient(135deg, ${theme.palette.background.paper} 30%, ${theme.palette.background.paper} 100%)`,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: { xs: "20px", sm: "20px", md: "0" },
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* Image Display Box */}
                <Box
                  sx={{
                    width: 200,
                    height: 200,
                    borderRadius: 1,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {imageData || profileData?.IMAGEPATH ? (
                    <img
                      src={imageData || `${profileData.IMAGEPATH}`} // Use imageData or fallback to LOGO
                      alt="Profile Image"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                        borderRadius: 100,
                        // width: 150,
                        // height: 150,
                        mt: 2,
                        border: `3px solid ${theme.palette.primary.main}`,
                        boxShadow: 3,
                        transition: "transform 0.3s",
                        "&:hover": { transform: "scale(1.1)" },
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        fontSize: 14,
                        color: "#888",
                        textAlign: "center",
                      }}
                    >
                      {/* <AccountCircleIcon /> */}
                      No Image Selected
                    </Box>
                  )}
                </Box>
                {/* <IconButton
                  component="label"
                 
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    mt: -2,
                    "&:hover": {
                      background: theme.palette.primary.dark,
                    },
                  }}
                >
                  <EditIcon />
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleImageChange}
                  />
                </IconButton> */}
                {/* Upload Button */}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",

                  alignItems: {
                    xs: "center",
                    sm: "center",
                    md: "center",
                    lg: "flex-start",
                    xl: "flex-start",
                  },
                  p: 3,
                  width: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mt: 2,
                    fontWeight: "bold",
                    color: theme.palette.text.primary,
                  }}
                >
                  {profileData
                    ? ` ${profileData.FIRSTNAME} ${profileData.LASTNAME}`
                    : "Loading..."}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color={theme.palette.text.secondary}
                  sx={{ textAlign: "center" }}
                >
                  {profileData ? profileData.USERNAME : "Loading..."}
                </Typography>
              </Box>
              <Box
                width={"100%"}
                display={"flex"}
                alignItems={"flex-end"}
                justifyContent={"flex-end"}
                flexDirection={"column"}
                gap={2}
                sx={{
                  height: {
                    xs: "auto",
                    sm: "auto",
                    md: "25vh",
                    lg: "25vh",
                    xl: "25vh",
                  },
                }}
              >
                <Button
                  component="label"
                  variant="contained"
                  sx={{ ...styles.btn_primary, maxWidth: "140px" }}
                  startIcon={<EditIcon />}
                >
                  Change Picture
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleImageChange}
                  />
                </Button>
                {imageData !== originalImagePath && imageData && (
                  <Button
                    variant="contained"
                    sx={{ ...styles.btn_primary, maxWidth: "120px" }}
                    onClick={handleEditClick}
                    id="btnconfirm"
                  >
                    Save Changes
                  </Button>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                ...styles.cb_col_1,
                maxHeight: "100vh",
                mt: 1,
                overflowY: "auto",
                borderRadius: 1,
                boxShadow: 2,
                p: 3,
                transition: "box-shadow 0.3s",
                "&:hover": { boxShadow: 6 },
                background: `linear-gradient(135deg, ${theme.palette.background.paper} 30%, ${theme.palette.background.paper} 100%)`,
              }}
            >
              {/* Fixed "My Profile" title */}
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  fontWeight: "bold",
                  color: theme.palette.primary.main,
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: theme.palette.background.paper,
                  padding: "8px 8px",
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              >
                My Profile
              </Typography>

              <Box
                sx={{
                  maxHeight: "62vh",
                  overflowY: "auto",
                  // height: {
                  //   xs: "auto",
                  //   sm: "auto",
                  //   md: "30vh",
                  //   lg: "30vh",
                  //   xl: "30vh",
                  // },
                }}
              >
                <Grid container spacing={2}>
                  {[
                    {
                      label: "First Name",
                      value: profileData ? profileData.FIRSTNAME : "Loading...",
                    },
                    {
                      label: "Last Name",
                      value: profileData ? profileData.LASTNAME : "Loading...",
                    },
                    {
                      label: "Designation",
                      value: profileData ? profileData.GROUPNAME : "Loading...",
                    },
                    {
                      label: "Company",
                      value: profileData ? profileData.COMPNAME : "Loading...",
                    },
                  ].map((item, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          p: 2,
                          // backgroundColor:
                          //   index % 2 === 0
                          //     ? theme.palette.background.default
                          //     : theme.palette.action.hover,
                          borderRadius: "4px",
                          border: `1px solid ${theme.palette.stroke.main}`,
                          boxShadow: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            color: theme.palette.text.secondary,
                          }}
                        >
                          {item.label}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: theme.palette.text.primary,
                            fontWeight: "bold",

                            backgroundColor: theme.palette.background.default,
                            py: 1,
                            px: 1,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Grid>

          {/* Profile Details Section */}
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}></Grid>
        </Grid>
      </Box>

      <Snackbar
        id="com_snack1"
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          id="com_al1"
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Profile Image Updated Successfully!
        </Alert>
      </Snackbar>
    </div>
  );
};

export default MyProfile;
